export const APPLICATION_STRINGS = {
    PLEASE_LOGIN : 'Please login before placing an order.',
    ORDER_ONE_ITEM : 'Orders must have at least one associated item',
    EMAIL_SENT : "Email Sent!",
    EMAIL_FAILED : "Email failed to send: ",
    SAF_ERROR : "There was an issue syncing offline transactions. Please try again later.",
}
